export class FormElementState {
    mandatory: boolean = false;
    visible: boolean = true;
    enabled: boolean = true;
}